module.exports = __webpack_public_path__ + "img/Weilin Vision PCB Board Recognition and Positioning Software.2ec54d1c.jpg";